import './mainLogin.css'
import PersLoginFake from './subElement/persLoginFake'
import MainLogin from './subElement/persLogin'

const Login =()=>{
    return <MainLogin />
}


export default Login